import { Box, TextField } from "@mui/material";
import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { ExcelButton } from "@/controls/buttons/ExcelButton";
import { PdfButton } from "@/controls/buttons/PdfButton";

interface Props {
	search: string;
	onSearchChange: (value: string) => void;
	onReset: () => void;
	canReset: boolean;
	onExportExcel: () => void;
	onExportPdf: () => void;
	canExportPdf: boolean;
	exportingPdf: boolean;
}

export const PartialRollsetsToolbar = ({
	search,
	onSearchChange,
	onReset,
	canReset,
	onExportExcel,
	onExportPdf,
	canExportPdf,
	exportingPdf,
}: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ width: 260 }}>
				<TextField
					size="small"
					label="Search"
					placeholder="Roll Set / Foundry / Description"
					fullWidth
					value={search}
					onChange={(e) => onSearchChange(e.target.value)}
				/>
			</Box>
			<ResetFiltersButton onClick={onReset} disabled={!canReset} />
			<Box sx={{ flexGrow: 1, minWidth: 8 }} />

			<Box sx={{ display: "flex", gap: 1 }}>
				<ExcelButton handleExportToExcel={onExportExcel} />
				<PdfButton
					handleExportToPdf={onExportPdf}
					disabled={!canExportPdf}
					loading={exportingPdf}
				/>
			</Box>
		</Box>
	);
};
